export const useStyles = theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  submitButton: {
    margin: '0 auto',
    width: 'auto',
    fontWeight: 'bold',
  },
  submitButtonDiv: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  loginLinkWrapper: {
    marginTop: theme.spacing(1),
  },
  loginLink: {
    textDecoration: 'underline',
    color: theme.palette.link,
    fontFamily: "'Montserrat', Helvetica, Arial, sans-serif",
  },
  '@global': {
    '.MuiFormHelperText-contained': {
      margin: '8px 0 0',
    },
  },
});
